import { useContext } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@mui/styles';
import Footer from '../Footer';
import FormWindow from '../FormWindow';
import Sidebar from '../Sidebar';
import styles from './Main.module.css';
import './Main.module.css';
import MainHeader from '../MainHeader';
import { CommonDataContext } from '../../../context';

const useStyles = makeStyles(() => ({
  height: {
    height: '20px',
  },
}));

const Main = (props: any) => {
  const classes = useStyles();
  const { children, repData, setRepData, publicAccount, partner, partnerLink, containerMaxWidth } = props;
  const pathName = window.location.pathname;
  const location = window.location.href;
  const isPartner = location.includes('/contact/');
  const isTaskPage = location.includes('task-page');
  const { isLenderDealerCoBranded, coBrandingSettings } = useContext(CommonDataContext);

  return (
    <>
      <Container
        maxWidth={containerMaxWidth}
      >
        <div className={classes.height} />
        <Grid
          container
          justifyContent={isPartner ? 'inherit' : 'center'}
          spacing={2}
        >
          <Grid
            item
            xs={12}
            lg={12}
            xl={pathName === `/bankUpload/` ? 12 : 9}
            className={styles.sameHeight}
          >
            {(partner || isLenderDealerCoBranded || isTaskPage) &&
              <MainHeader
                partner={partner}
                isLenderDealerCoBranded={isLenderDealerCoBranded}
                coBrandingSettings={coBrandingSettings}
                isTaskPage={isTaskPage}
                publicAccount={publicAccount}
              />
            }
            <FormWindow setRepData={setRepData}>
              {children}
            </FormWindow>
          </Grid>
          <Grid
            item
            xs={12}
            lg={12}
            xl={pathName === `/bankUpload/` ? 12 : !isPartner ? 3 : 0}
            className={styles.sameHeight}
          >
            <Sidebar
              repData={repData}
              publicAccount={publicAccount}
              setRepData={setRepData}
              partnerLink={partnerLink}
            />
          </Grid>
        </Grid>
        <div className={classes.height} />
      </Container>
      <Footer />
    </>
  );
};

export default Main;
